import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=0af679b4&scoped=true"
import script from "./HomeDesktop.vue?vue&type=script&lang=js"
export * from "./HomeDesktop.vue?vue&type=script&lang=js"
import style0 from "./HomeDesktop.vue?vue&type=style&index=0&id=0af679b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af679b4",
  null
  
)

export default component.exports